/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ColumnChartProps } from '../../ColumnChart.props';

export const getColumnChartGeneralOptions = (options: ColumnChartProps): Highcharts.Options => {
  const { title, subtitle, headerAlignment, hideLegend, staticChart } = options;
  return {
    chart: {
      type: 'column',
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: hideLegend ? false : true,
    },
    plotOptions: {
      column: {
        states: {
          hover: {
            enabled: staticChart ? false : true,
          },
        },
      },
    },
    subtitle: {
      align: headerAlignment ?? 'center',
      text: subtitle,
      useHTML: true,
    },
    title: {
      align: headerAlignment ?? 'center',
      text: title,
      useHTML: true,
    },
    tooltip: {
      enabled: staticChart ? false : true,
    },
  };
};
